import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsServiceName as FormViewServiceName,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as LookupManagementServiceProviderName } from "../../../shared/lookups";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../../../records/lookup/lookupManagement";
import { MachineManufacturer } from "../../../shared/models/machine";

export const vsObjectName = "machineManufacturer";

const url = "/api/machines/MachineManufacturer";

export function machineManufacturerLookupConfig(
  lookupManagementServiceProvider: LookupManagementServiceProvider,
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureLookupManagement(lookupManagementServiceProvider);
  configureForm(formViewServiceProvider);
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
}
machineManufacturerLookupConfig.$inject = [
  LookupManagementServiceProviderName,
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
];

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    FormViewServiceName,
    (formViewService: FormViewService): FormViewConfig => {
      return {
        fields: [
          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Manufacturer",
            required: true,
          }),
          fieldHelpers.simpleBoolField({
            key: "Disabled",
            name: "Disabled",
            label: "Disabled?",
            defaultValue: false,
          }),
        ],
        name: vsObjectName,
        submitForm: (args: FormSubmitArgs) => {
          const model = <MachineManufacturer>args.model;
          return formViewService.saveForm({
            formObject: model,
            formViewController: args.formViewController,
            url: "/api/machines/MachineManufacturer",
          });
        },
        title: (model: MachineManufacturer) =>
          model.Id ? "Edit Manufacturer" : "Create Manufacturer",
      };
    },
  ]);
}

function configureLookupManagement(
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Manufacturer",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility): LookupManagementConfig => {
        return {
          fetchFormModel: (id: number) =>
            serverUtility.querySingle({
              url,
              query: { Id: id },
            }),
          baseUrl: url,
        };
      },
    ],
  });
}

function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Manufacturer",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Disabled",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Manufacturers",
    nameSingular: "Manufacturer",
    showAddButton: true,
    showAddButtonPermission: "machineLookupModify",
    showSelectButtons: false,
  };
}
getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
